export const ROUTES = {
  BASE: "/",
  TERMS_AND_CONDITIONS: "/terms-and-conditions",
  PRIVACY_POLICY: "/privacy-policy",
  ABOUT_US:"/about-us",
  CONTACT_US:"/contact-us",
  LOGIN:"/login",
  REGISTER:"/register",
};